module.exports = __webpack_public_path__ + "static/unity_img_2-5f3f28328b02f752307cc99d6ed964f2.png";